import React from 'react';

const GalleryModal = ({ open, image, onClose, onPrev, onNext, hasPrev, hasNext }) => {
    if (!open) return null;
    return (
        <div className="gallery-modal-backdrop" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.7)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }} onClick={onClose}>
            <div style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }} onClick={e => e.stopPropagation()}>
                <img src={image} alt="gallery-large" style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: 12 }} />
                <button onClick={onClose} style={{ position: 'absolute', top: 10, right: 10, background: 'white', border: 'none', borderRadius: '50%', width: 32, height: 32, fontSize: 18, cursor: 'pointer' }}>×</button>
                {hasPrev && <button onClick={onPrev} style={{ position: 'absolute', top: '50%', left: 0, transform: 'translateY(-50%)', background: 'white', border: 'none', borderRadius: '50%', width: 32, height: 32, fontSize: 18, cursor: 'pointer' }}>{'>'}</button>}
                {hasNext && <button onClick={onNext} style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)', background: 'white', border: 'none', borderRadius: '50%', width: 32, height: 32, fontSize: 18, cursor: 'pointer' }}>{'<'}</button>}
            </div>
        </div>
    );
};

export default GalleryModal;
